"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var styles = _interopRequireWildcard(require("./Button.css"));
const _excluded = ["children", "deviceType"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Button = _ref => {
  let {
      children,
      deviceType
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: props.onClick,
    disabled: props.disabled,
    className: (0, _classnames.default)(styles['btn'], props.loading && styles['btn-loading'], styles[`btn--${deviceType}`])
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: styles['spinner'],
    "data-testid": "spinner"
  }, /*#__PURE__*/React.createElement(_uiKit.Spinner, {
    size: 16
  })), /*#__PURE__*/React.createElement("span", {
    className: (0, _classnames.default)(styles['content'], styles[`content--${deviceType}`], {
      [styles['content-loading']]: props.loading
    })
  }, children));
};
exports.Button = Button;